import { createAction } from "@reduxjs/toolkit";

export const saveBasicInfoField = createAction("auth/saveBasicInfoField");
